import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {TradeEntity} from '../Entities/TradeEntity.js'

/**
 * @implements UseCase
 */
export class GetTradeCostsListTransactionsUseCase extends UseCase {
  constructor({httpTransactionsRepository}) {
    super()
    this._httpTransactionsRepository = httpTransactionsRepository
  }

  @inlineError
  async execute({tradeId}) {
    const tradeEntity = TradeEntity.create({
      id: tradeId
    })

    const [error, response] = await this._httpTransactionsRepository.getTradeCostsList(tradeEntity)

    if (error) return Promise.reject(error)

    return response.toJSON()
  }
}
